<template>

  <b-modal id="UsuarioNew" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Nuevo Usuario</h5>
      <button type="button" aria-label="Close" class="close" @click="close()" :disabled="loading">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="crear" ref="form">

        <div class="final_form_container">

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Email</label>
              <b-form-input class="inputText" v-model="usuario.mail" type="email" autofocus="autofocus" required :disabled="loading"></b-form-input>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Nombres</label>
              <b-form-input class="inputText" v-model="usuario.nombre" type="text" required :disabled="loading"></b-form-input>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Apellidos</label>
              <b-form-input class="inputText" v-model="usuario.apellido" type="text" required :disabled="loading"></b-form-input>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Zona Horaria</label>
              <treeselect class="inputRelation required" v-model="usuario.time_zone" :clearable="false" :disable-branch-nodes="true" placeholder="" 
              :disabled="loading" required :options="time_zones" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">La contraseña expira?</label>
              <b-form-checkbox class="inputCheckbox" style="display: inline-flex !important;"
                v-model="usuario.password_expire" value="t" unchecked-value="f"
                switch size="md">
              </b-form-checkbox>
          </div>

          <div class="final_form_input_group" v-if="usuario.password_expire">
              <label class="final_form_group_input_label" for="browser_first_name">Cada cuántos días?</label>
              <treeselect class="inputRelation required" v-model="usuario.password_expire_days" :clearable="false" :disable-branch-nodes="true" placeholder="" 
              :disabled="loading || !usuario.password_expire" required :options="expireoptions" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Rol</label>
              <treeselect class="inputRelation required" v-model="rolasignado" :clearable="false" :disable-branch-nodes="true" placeholder="" 
              :disabled="loading" required :options="roles" :auto-load-root-options="false" :cache-options="false" :open-on-focus="true"/>
          </div>

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Grupos de Trabajo</label>
              <b-form-checkbox-group class="formGroupChecks" v-model="empresasasignadas" :options="empresasnoasignadas" switches
                stacked value-field="id" text-field="name" :disabled="loading" size="md">
              </b-form-checkbox-group>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>

import Treeselect from '../../utils/vue-treeselect/src/components/Treeselect'

export default {
  components: {
    Treeselect
  },
  data () {
    return {
      loading: false,
      usuario: {
        userid: '',
        nombre: '',
        apellido: '',
        mail: '',
        enable: true,
        password_expire: false,
        password_expire_days: 0,
        password_expire_lastdate: '',
        error: ''
      },
      rolasignado: undefined,
      roles: [],
      empresasasignadas: [],
      empresasnoasignadas: [],
      expireoptions : [
        { label: 0, id: 0 },
        { label: 15, id: 15 },
        { label: 30, id: 30 },
        { label: 60, id: 60 },
        { label: 90, id: 90 },
        { label: 120, id: 120 },
      ],
      time_zones : [
        { label: 'America/Asuncion', id: 'America/Asuncion' },
        { label: 'America/Bogota', id: 'America/Bogota' },
        { label: 'America/Buenos_Aires', id: 'America/Buenos_Aires' },
        { label: 'America/Guayaquil', id: 'America/Guayaquil' },
        { label: 'America/La_Paz', id: 'America/La_Paz' },
        { label: 'America/Lima', id: 'America/Lima' },
        { label: 'America/Montevideo', id: 'America/Montevideo' },
        { label: 'America/New_York', id: 'America/New_York' },
        { label: 'America/Santiago', id: 'America/Santiago' },
        { label: 'US/Alaska', id: 'US/Alaska' },
        { label: 'US/Arizona', id: 'US/Arizona' },
        { label: 'US/Central', id: 'US/Central' },
        { label: 'US/Hawaii', id: 'US/Hawaii' },
        { label: 'US/Pacific', id: 'US/Pacific' },
        { label: 'US/Samoa', id: 'US/Samoa' },
        { label: 'Universal', id: 'Universal' },
      ],
    }
  },
  methods: {
    init () {
      try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          localStorage.page_return = ""

          this.usuario = {
            userid: '',
            nombre: '',
            apellido: '',
            mail: '',
            enable: true,
            password_expire: false,
            password_expire_days: 0,
            password_expire_lastdate: '',
            error: ''
          },
          this.rolasignado = undefined;
          this.roles = []
          this.empresasasignadas = []
          this.empresasnoasignadas = []

          this.getRolesNoAsignados()
            .then(data => {
              this.roles = data.items
            })

          this.getEmpresasNoAsignadas()
            .then(data => {
              this.empresasnoasignadas = data.items
            })
        } 
      } catch (error) {
        this.showError(error)
      }
    },
    validateEmail(email) { // no lo uso
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    crear () {
      try {

        this.loading = true

        if(this.validateEmail(this.usuario.mail)) {
          
          var empresas = []

          this.empresasasignadas.forEach(empresassi => {
              this.empresasnoasignadas.forEach(empresasno => {
                if (empresassi == empresasno.id) {
                  empresas.push({v2_empresa_id: empresasno.id})
                }
            });
          });

          var data = {};
          var v2_usuario = {
            userid: this.cs(this.usuario.mail), 
            nombre: this.cs(this.usuario.nombre), 
            apellido: this.cs(this.usuario.apellido), 
            mail: this.cs(this.usuario.mail),
            time_zone: this.usuario.time_zone,
            password_expire: ((this.usuario.password_expire_days == 0)?false:this.usuario.password_expire),
            password_expire_days: this.usuario.password_expire_days
          }
          data.v2_usuario = v2_usuario;
          data.rol = this.rolasignado;
          data.empresas = empresas;

          this.$http.secured.post('/auth/v1/users/', data )
            .then(response => {
              this.loading = false
              this.showOK("Se creó el usuario correctamente!")
              this.$emit('closeModal')
              this.$refs.modal.hide()
            })
            .catch(error => {
              this.loading = false
              this.showError(error)
            })  
        } else {
          this.loading = false
          this.showError("Debe ingresar un Email válido")
        } 

      } catch (error) {
        this.loading = false
        this.showError(error)
      }

    }
  }
}
</script>


